import styled from 'styled-components';

export const Container = styled.div`
`;

export const ImoveisList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 1rem 0;
`;

export const ImovelItem = styled.li`
  padding: 0.75rem 1rem;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
  
  &:hover {
    background-color: #0E2244;
    color: #fff !important;
    p {
      color: #fff !important;
    }
  }
`;

export const ImovelDescricao = styled.p`
  margin-top: 0.25rem;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
`;

export const CarrosselTitle = styled.p`
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

export const WarningText = styled.p`
  font-size: 0.95rem;
  color: #ff4d4f;
  margin-top: 1rem;
  font-weight: 500;
`;
export const AddedTag = styled.span`
  margin-left: auto;
  color: #1d4ed8; /* text-blue-700 */
  background-color: #dbeafe; /* bg-blue-100 */
  font-size: 0.875rem; /* text-sm */
  padding: 0.125rem 0.5rem; /* py-0.5 px-2 */
  border-radius: 0.375rem; /* rounded */
  font-weight: 500; /* font-medium */
`;

